/**
 * Returns whether the supplied value is neither null nor undefined
 *
 * @param value
 *      the value to check
 */
export function notNull<TValue>(value: TValue | null | undefined): value is TValue {
    return value != null;
}

/**
 * A filter which filter out duplicate values in order to get an array with distinct values.
 *
 * @param value
 * @param index
 * @param self
 */
export function distinct<TValue>(value: TValue, index: number, self: TValue[]) {
    return self.indexOf(value) === index;
}

/**
 * Returns the index of the last element in the array where predicate is true, and -1
 * otherwise.
 * @param array The source array to search in
 * @param predicate find calls predicate once for each element of the array, in descending
 * order, until it finds one where predicate returns true. If such an element is found,
 * findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
 */
export const findLastIndex = <T>(
    array: Array<T>,
    predicate: (value: T, index: number, obj: T[]) => boolean
): number => {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array)) return l;
    }
    return -1;
};

export const filterByValue = (array, filter) => {
    return array.filter(
        o =>
            filter == '' ||
            Object.keys(o).some(
                k => typeof o[k] === 'string' && o[k].toLowerCase().includes(filter.toLowerCase())
            )
    );
};
